import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { MapComponent } from '../../map/components/map-component/map.component';
import { CurrentStateService } from '../../../core/services/current-state.service';
import { MENU_OPTIONS } from '../../../shared/constants/left-menu-option';
import { LocalStorageService } from '../../../shared/services/utilities/local-storage.service';

@Component({
  selector: 'app-event-page',
  standalone: true,
  imports: [
    CommonModule,
    MapComponent
  ],
  templateUrl: './event-page.component.html',
  styleUrls: ['./event-page.component.scss']
})
export class EventPageComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  menuType = MENU_OPTIONS.EVENT;
  constructor(
    private currentStateService: CurrentStateService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.currentStateService.setCurrentMenu(MENU_OPTIONS.EVENT);
    this.localStorageService.setItem('currentMenu', MENU_OPTIONS.EVENT);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}